import { translate } from 'i18n/i18n'
import { isNil } from 'lodash'
import { getInsectNameFromId } from 'utils/getInsectNameFromId'
import type { TUnitConverterTypicalReturn } from '../types'

const DEFAULT_DECIMAL_PLACES = 1

const larvalTrend = (
  numberOfCatches: number | null = null,
  {
    insectId = -1,
    decimalPlaces = DEFAULT_DECIMAL_PLACES,
  }: {
    insectId?: number
    decimalPlaces?: number
  } = {},
): TUnitConverterTypicalReturn => {
  let convertedValue: number | null

  if (isNil(numberOfCatches)) {
    convertedValue = null
  } else {
    convertedValue = Number(numberOfCatches)
  }

  return {
    categoryTitle: () => translate.phrases.banyanApp('Larval Trend'),
    categoryTitleWithoutUnit: () => translate.phrases.banyanApp('Larval Trend'),
    defaultNumberOfDecimalPlaces: () => DEFAULT_DECIMAL_PLACES,
    suffix: () => '',
    shortTitle: () => {
      return translate.phrases.banyanApp('{{insectName}} Larval Trend', {
        insectName: getInsectNameFromId(insectId),
      })
    },
    title: () => {
      return translate.phrases.banyanApp('{{insectName}} Larval Trend', {
        insectName: getInsectNameFromId(insectId),
      })
    },
    titleWithoutUnit: () => {
      return translate.phrases.banyanApp('{{insectName}} Larval Trend', {
        insectName: getInsectNameFromId(insectId),
      })
    },
    value: () => {
      if (isNil(convertedValue)) return null

      return +convertedValue?.toFixed(decimalPlaces)
    },
    valueAsString: () => `${convertedValue?.toFixed(decimalPlaces) ?? translate.phrases.templates('-')}`,
    valueWithSuffix: () => {
      if (isNil(convertedValue)) return translate.phrases.templates('-')

      return convertedValue.toFixed(decimalPlaces)
    },
    valueWithNoRounding: () => convertedValue,
  }
}

export const insectLarvalTrend = {
  insectLarvalTrend: larvalTrend,
}
